export const GET_DATA = 'getData';
export const LOADING = 'loading';
export const ERROR = 'error';